module.exports = new __parcel__URL__("soleil-voile-pluie-2.ce97767c.svg").toString();